<template>
    <div id="send-sms-posta-guvercini">
        <div class="header">
            <div class="title">{{ $t("message.sendSms") }}</div>
            <div class="subtitle">{{ $t("message.sendSmsYourCustomers") }}</div>
        </div>
        <SendSmsInput :channel="channel" :credit="credit" @sendSMS="sendSMS" />
    </div>
</template>
<script>
import { mapState } from "vuex";
import SendSmsInput from "./SendSmsInput.vue";
import { generateUUID } from "../../../../../../utils/session";
import { sendSocketMessage } from "../../../../../../utils/socketStream";

export default {
    name: "SendSmsPostaGuvercini",
    props: ["channel", "credit"],
    components: { SendSmsInput },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
        }),
    },
    methods: {
        sendSMS({ text, number }) {
            const payload = {
                siteId: this.site._id,
                channelId: this.channel._id,
                channelType: "sms-posta-guvercini",
                number,
                message: text,
                senderId: null,
                title: null,
                customMessageId: generateUUID(),
            };
            sendSocketMessage("sms send-single", payload);
        },
    },
};
</script>
<style scoped lang="scss">
#send-sms-posta-guvercini {
    .header {
        display: flex;
        justify-content: space-between;
        padding-top: 10px;
        padding-bottom: 10px;
        border-bottom: 1px solid var(--color-border-default);

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
            padding-left: 5px;
        }

        .subtitle {
            font-size: 14px;
            color: var(--color-text-strong-default);
        }
    }
}
</style>
